import React, { useEffect, useRef, useState } from 'react';
import { IoCheckmarkCircle, IoCloseCircle } from 'react-icons/io5';

const CustomToast = ({ message, type = 'success', onClose, duration = 4000 }) => {
  const progressRef = useRef(null);
  const frameRef = useRef();
  const remainingRef = useRef(duration);
  const targetRef = useRef(performance.now() + duration);
  const [isPaused, setIsPaused] = useState(false);

  const animate = () => {
    const now = performance.now();
    const remaining = targetRef.current - now;
    const pct = Math.max((remaining / duration) * 100, 0);

    if (progressRef.current) {
      progressRef.current.style.width = `${pct}%`;
    }

    if (remaining <= 0) {
      onClose();
    } else {
      frameRef.current = requestAnimationFrame(animate);
    }
  };

  useEffect(() => {
    if (isPaused) {
      remainingRef.current = targetRef.current - performance.now();
      cancelAnimationFrame(frameRef.current);
    } else {
      targetRef.current = performance.now() + remainingRef.current;
      frameRef.current = requestAnimationFrame(animate);
    }

    return () => cancelAnimationFrame(frameRef.current);
  }, [isPaused]);

  const baseStyles =
    'fixed top-2 right-2 pt-4 px-4 pb-1 rounded-lg shadow-lg flex items-start gap-2 z-50 transform transition-all duration-300 ease-in-out w-[calc(100vw-1rem)] max-w-sm';
  const toastStyles =
    type === 'success'
      ? `${baseStyles} bg-green-500 border border-green-200 text-white`
      : `${baseStyles} bg-red-500 border border-red-200 text-white`;

  const icon =
    type === 'success' ? (
      <IoCloseCircle className="w-5 h-5 text-white" />
    ) : (
      <IoCloseCircle className="w-5 h-5 text-white" />
    );
  const barColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';

  return (
    <div
      className={toastStyles}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)} style={{zIndex: "999999999999999999999"}}
    >
      <div className="flex flex-col w-full">
        <div className="flex items-start justify-between min-h-0">
          <div className="max-h-16 overflow-y-auto pr-2 text-sm font-medium whitespace-pre-wrap break-words">
            {message}
          </div>
          <button onClick={onClose} className="ml-2 shrink-0 text-white/90 hover:text-white">
            {icon}
          </button>
        </div>
        <div className="w-full h-0.5 bg-gray-200 mt-2 overflow-hidden relative">
          <div ref={progressRef} className={`h-full ${barColor}`} style={{ width: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
